import { render } from "./BaseImage.vue?vue&type=template&id=000a7f1e&scoped=true"
import script from "./BaseImage.vue?vue&type=script&lang=js"
export * from "./BaseImage.vue?vue&type=script&lang=js"

import "./BaseImage.vue?vue&type=style&index=0&id=000a7f1e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-000a7f1e"

export default script